import React from 'react';
import { holderInitials } from './keyRegisterLabels';

/** A small grey circle with the holder's initials, followed by the name. */
const HolderAvatar: React.FC<{ name: string }> = ({ name }) => (
    <span className="key-holder">
        <span className="key-holder-avatar" aria-hidden="true">{holderInitials(name)}</span>
        <span className="key-holder-name">{name}</span>
    </span>
);

export default HolderAvatar;
